(function () {
  window.KISY_URL_CONFIG = window.KISY_URL_CONFIG || {
    localBaseUrl: 'http://127.0.0.1:9292',
    productionBaseUrl: 'https://www.kisy.com.mx',
    localHostnames: ['127.0.0.1', 'localhost', '0.0.0.0'],
    productionHostnames: ['www.kisy.com.mx', 'kisy.com.mx']
  };

  const config = window.KISY_URL_CONFIG;

  function getCurrentEnvironment() {
    const hostname = window.location.hostname.toLowerCase();

    if (config.localHostnames.includes(hostname) || hostname.includes('127.0.0.1') || hostname.includes('localhost')) {
      return 'local';
    }

    if (config.productionHostnames.includes(hostname) || hostname.endsWith('kisy.com.mx')) {
      return 'production';
    }

    return 'unknown';
  }

  function buildMappedUrl(pathname, search, hash, baseUrl) {
    const cleanPath = pathname || '/';
    return `${baseUrl}${cleanPath}${search || ''}${hash || ''}`;
  }

  function mapUrl(url) {
    if (!url || typeof url !== 'string') {
      return url;
    }

    const trimmedUrl = url.trim();

    if (
      !trimmedUrl ||
      trimmedUrl.startsWith('#') ||
      trimmedUrl.startsWith('mailto:') ||
      trimmedUrl.startsWith('tel:') ||
      trimmedUrl.startsWith('javascript:') ||
      trimmedUrl.startsWith('data:')
    ) {
      return trimmedUrl;
    }

    try {
      const parsed = new URL(trimmedUrl, window.location.origin);
      const environment = getCurrentEnvironment();
      const isProductionUrl = config.productionHostnames.includes(parsed.hostname.toLowerCase()) || parsed.hostname.toLowerCase().endsWith('kisy.com.mx');
      const isLocalUrl = config.localHostnames.includes(parsed.hostname.toLowerCase()) || parsed.origin === config.localBaseUrl;

      if (environment === 'local' && isProductionUrl) {
        return buildMappedUrl(parsed.pathname, parsed.search, parsed.hash, config.localBaseUrl);
      }

      if (environment === 'production' && isLocalUrl) {
        return buildMappedUrl(parsed.pathname, parsed.search, parsed.hash, config.productionBaseUrl);
      }

      return trimmedUrl;
    } catch (error) {
      return trimmedUrl;
    }
  }

  function rewriteLinks(root) {
    if (!root) {
      return;
    }

    const anchors = root.querySelectorAll ? root.querySelectorAll('a[href]') : [];

    anchors.forEach((anchor) => {
      const originalHref = anchor.getAttribute('href');
      const nextHref = mapUrl(originalHref);

      if (nextHref && nextHref !== originalHref) {
        anchor.setAttribute('href', nextHref);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    rewriteLinks(document);

    if (window.MutationObserver) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node && node.nodeType === 1) {
              rewriteLinks(node);
            }
          });
        });
      });

      observer.observe(document.body || document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  });
})();
